import { TFunction } from 'i18next';
import { CardApprovalRequest } from '../../../../queries/pxtraCard';

/** Q.2: an open request expires 30 days after it arrives. */
export const EXPIRY_WARNING_DAYS = 7;

/** Null has no deadline, so nothing about it is due — not Epoch, which reads
 * as expired twenty thousand days ago. */
export const daysUntil = (isoDate: string | null): number | null => {
  if (!isoDate) return null;

  const target = new Date(isoDate).setHours(0, 0, 0, 0);
  const today = new Date().setHours(0, 0, 0, 0);
  return Math.round((target - today) / (1000 * 60 * 60 * 24));
};

export const isDecidable = (request: CardApprovalRequest): boolean =>
  request.status === 'open' || request.status === 'failed';

export const sumCost = (requests: CardApprovalRequest[]) =>
  requests.reduce(
    (total, request) => ({
      one_off_cents: total.one_off_cents + request.cost.one_off_cents,
      recurring_monthly_cents: total.recurring_monthly_cents + request.cost.recurring_monthly_cents
    }),
    { one_off_cents: 0, recurring_monthly_cents: 0 }
  );

/**
 * What went wrong, in the reader's language where we know the reason, and in
 * Swan's words where only Swan does.
 */
export const failureText = (
  request: Pick<CardApprovalRequest, 'failure_code' | 'failure_reason'>,
  t: TFunction
): string => {
  if (request.failure_code) {
    return t(`pxtraCard:failure_${request.failure_code}`, {
      defaultValue: request.failure_reason ?? ''
    });
  }

  return request.failure_reason ?? '';
};
